import { fetchWrapper } from '../../utils';

export class chat {
  static baseUrl = process.env.REACT_APP_BASE_API + 'chat';


  static async getChats(params) {
    const url = `${this.baseUrl}`;
    return await fetchWrapper.post(url, params);
  }

  static async getParents(params) {
    const url = `${this.baseUrl}/parents`;
    return await fetchWrapper.post(url, params);
  }



  static async viewChats(params) {
    const url = `${this.baseUrl}/view`;
    return await fetchWrapper.post(url, params);
  }

  static async send(params) {
    const url = `${this.baseUrl}/send`;
    return await fetchWrapper.post(url, params);
  }

}
